// extracted by mini-css-extract-plugin
module.exports = {"key":"key_key__H_Y00","keyCap":"key_keyCap__N1WYI","pressed":"key_pressed__22KJ8","label":"key_label__UKloY"};